import React from 'react'
import { ChartsReferenceLine, ChartsXAxis, ChartsYAxis } from '@mui/x-charts'
import { formatCurrency } from 'Components/Charts/CampaignMultiLineChart/utils'
import { formatNumberCompact } from '../utils'

type ChartAxisOptionsProps = {
  target?: number | null
  unitOfMeasurement?: string | null
  isCampaignGoal: boolean
}

export const ChartAxisOptions: React.FC<ChartAxisOptionsProps> = ({
  target,
  unitOfMeasurement = '',
  isCampaignGoal = false,
}: ChartAxisOptionsProps) => {
  if (!target || !unitOfMeasurement) return null

  return (
    <>
      <ChartsXAxis
        label='Date'
        labelStyle={{ fontWeight: 'bold' }}
        scaleType='band'
      />
      <ChartsYAxis
        label={unitOfMeasurement}
        labelStyle={{ fontWeight: 'bold' }}
        scaleType='linear'
      />
      {target && (
        <ChartsReferenceLine
          lineStyle={{ strokeDasharray: '10 5' }}
          y={target}
          label={`Target: ${
            isCampaignGoal
              ? formatCurrency(target)
              : formatNumberCompact(target)
          }`}
          labelAlign='end'
        />
      )}
    </>
  )
}
